<template>
  <VueTelInput
    ref="vueTel"
    v-model="phone"
    class="app-phone-input"
    :disabled="disabled"
    :placeholder="$t('Write here')"
  />
</template>

<script>
    import VueTelInput from 'vue-tel-input'
    import 'vue-tel-input/dist/vue-tel-input.css';

    export default {
        name: "AppPhoneInput",

        components: {
            VueTelInput
        },
        props: ['value', 'disabled'],
        computed: {
            phone: {
                get() {
                    return this.value
                },
                set(data) {
                    this.$emit('input', data);
                }
            }
        },
        methods:{
            validate(){
                return  this.$refs['vueTel'].response.isValid;
            }
        }
    }
</script>

<style>
    .app-phone-input {
        background-color: rgba(175, 172, 250, 0.05) !important;
        border: 1px solid var(--secondary-color) !important;
        border-radius: 3px;
        box-shadow: none;
        height: 32px;
    }
    .app-phone-input ul {
        width: 335px !important;
    }

    .app-phone-input input {
        background-color: rgba(175, 172, 250, 0.01) !important;
        color: black;    
    }
    .app-phone-input input::placeholder {
        color: #c5c8ce;    
    }

    .app-phone-input:hover {
        border: 1px solid var(--secondary-color);
        box-shadow: 0 0 4px 2px rgb(175, 172, 250, 0.3);
    }
</style>
